// Note: Trimble Maps uses Mercator projection by default
// Globe projection is not supported in Trimble Maps SDK
// This component is kept for potential future use or custom implementations

module.exports = function (context) {
  return function (selection) {
    // Trimble Maps currently only supports Mercator projection
    // Hiding projection switch as it's not applicable
    const container = selection
      .append('div')
      .attr(
        'class',
        'projection-switch absolute left-0 bottom-0 mb-16 text-xs transition-all duration-200 z-10 hidden'
      );

    container.append('span').attr('class', 'bg-white p-[4px]').text('Mercator');
  };
};
